// src/components/ExternalRedirect.jsx
import React, { useEffect } from 'react';

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  // 리다이렉션이 실행되기 전까지 잠시 보여줄 내용 (보통 null 또는 로딩 메시지)
  return null;
}

export default ExternalRedirect;